var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Contact ")]},proxy:true},{key:"content",fn:function(){return [_c('div',[_c('p',[_vm._v("Soon.")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }